import { amountAsCurrency } from "currency";
import { View } from "react-native";
import { Text } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import Row from "./Row";
import { TransactionDetails } from "../../../types";
import CardText from "../../CardText";

type Props = {
  cartInfo: TransactionDetails["payment"]["cartInfo"];
};

export default function CartInfo({ cartInfo }: Props) {
  const tailwind = useTailwind();

  if (!cartInfo) {
    return null;
  }

  const { itemsCount, subTotal, currency } = cartInfo;

  const items = `${itemsCount} producto${itemsCount == 1 ? "" : "s"}`;
  const price = amountAsCurrency({ amount: subTotal, currency });

  return (
    <View style={tailwind("mt-4")}>
      <CardText.Title text="Subtotal" style={tailwind("mb-1")} />
      <Row>
        <Text>{items}</Text>
        <Text>{price}</Text>
      </Row>
    </View>
  );
}
